import axios from 'axios'
export default {
  name: 'enviarpedido',
  components: { },
  data () {
    return {
      ip: '', lugar: 0, proveedores: [], direccion_barraca: '',
      errores: [], nombre: '', telefono: '', mail:'', direccion: ''
    }
  },
  beforeCreate () {
    if (this.$store.getters.cantidadpiezas < 1 ){
      this.$router.push('/listador')
    }
  },
  mounted() {
    this.consultarproveedores()        
  },
  methods: {
    consultarproveedores: function () {
      if (this.$store.getters.empresareferida === 141 || this.$store.getters.empresareferida === 151) {
        this.proveedores = this.$store.getters.datosempresareferida
      } else {
        axios.get(this.$apibase+'gen/proveedores/', {
            params: {
              'cliente': this.$store.getters.idactual,'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
            }
          })
          .then( response => this.pasoproveedoresapi(response),  response => this.errorproveedoresapi(response) )
          .catch( response => this.errorproveedoresapi(response))
      }
    },
    pasoproveedoresapi: function (response) {
      if(response.data.estado === 1){
        this.proveedores = response.data.proveedores
      }
    },
    errorproveedoresapi: function (response) {
      
    },
    cargarpedido: function (event) {
      if (event) {
        event.preventDefault()
        let pedido = []
        let cliente = []
        if (this.$store.getters.islogin === true){
          cliente.push({'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual })  
        } else {
          cliente.push({ 'nombre': this.nombre, 'telefono': this.telefono, 'mail': this.mail, 'direccion': this.direccion} )  
        }
        
        pedido.push({'cliente': cliente})
        pedido.push({'piezas': this.$store.getters.piezas })

        if (this.$store.getters.escarpintero === true){
          pedido.push({'lugar': parseInt(this.lugar)})
          if (this.verificarenviobarraca === true) {
            pedido.push({'direccion_barraca': this.direccion_barraca})
          }
          if (this.$store.getters.color_canto === '') {
            this.$store.dispatch('CAMBIAR_COLOR_CANTO', 'Blanco')
          }
          if (this.$store.getters.color_placa === '') {
            this.$store.dispatch('CAMBIAR_COLOR', 'Blanco')
          }
          pedido.push({'color_canto': this.$store.getters.color_canto})
          pedido.push({'color_placa': this.$store.getters.color_placa})
        }
        pedido.push({'descripcion': this.$store.getters.descripcion })
        pedido.push({'placa': this.$store.getters.placa })
        pedido.push({'canto': this.$store.getters.canto })
        pedido.push({'mt2': this.$store.getters.totalmt2 })
        pedido.push({'mtl045': this.$store.getters.totalmtl045 })
        pedido.push({'mtl2': this.$store.getters.totalmtl2 })
        pedido.push({'mtcorte': this.$store.getters.totalmtscorte })
        
        this.enviarpedidoapi(pedido)
      }
    },
    enviarpedidoapi: function (pedido) {
      var empresa = this.$store.getters.url_empresa
      axios.post(this.$apibase+'gen/pedido', {
        "pedido": pedido, "cred": this.$store.getters.credactual, "empresa": empresa
      })
      .then( response => this.pasopedidoapi(response),  response => this.errorpedidoapi(response) )
      .catch( response => this.errorpedidoapi(response))
    },
    volveratras: function (event) {
      this.$router.push('/listador')
    },
    pasaracompleto: function (id) {
      var link = '/pedidocompleto/'+id
      if (parseInt(this.lugar) === 1) {
        link = link + '/1'
      }
      this.$router.push(link)
    },
    pasopedidoapi: function (respuesta) {
      if (respuesta.data.pedido.estado === 1) {
        if (respuesta.data.credenciales) {
          this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales)
        }
        if (respuesta.data.pedido.url) {
         this.$store.dispatch('SET_URL_VER', respuesta.data.pedido.url) 
        }
        this.$store.dispatch('REINICIAR_PEDIDO')
        this.pasaracompleto(respuesta.data.pedido.idnuevo)
      } else {
        console.log(' no ingreso el pedido')
      }
    },
    errorpedidoapi: function (respuesta) {
      console.log(event)
      console.log('error')
    },
    verificartelefono: function (actual) {
      var input = actual.replace(/[\D\s\._\-]+/g, "")
      var re = "/(\d{3})(\d{3})(\d{3})/g"
      var nuevo = input.replace(re, "$1$2$3")
      var codigo = actual.replace(re, "$1")
      return true
    },
    validEmail:function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  computed: {
    datosvalidos: function () {

    },
    verificarenviobarraca: function () {
      if (this.lugar > 1 && this.lugar !== this.$store.getters.idactual) {
        return true
      }
      return false
    },
    verificarformlogin: function (event) {
      this.errores = []
      if (this.lugar < 1) {
        this.errores.push("Debe seleccionar un lugar")
      }
      if (this.biblioteca < 1) {
        this.errores.push("Seleccione si desea guardar")
      }
      if (this.biblioteca === '1' && this.carpeta <= 0) {
       this.errores.push("Seleccione una Carpeta") 
      }
      if (this.verificarenviobarraca === true && this.direccion_barraca === '') {
        this.errores.push("Indique una dirección para envío")
      }
      if(!this.errores.length) {
        return true
      } else {
        return false
      }
    },
    verificarform: function (event) {
      this.errores = []
      if(this.$store.getters.islogin !== true) {
        if (this.nombre === '') {
          this.errores.push("Indique su Nombre")
        }
        if (this.direccion === ''){
          this.errores.push("Indique una Dirección para envío")
        }
        if (!this.validEmail(this.mail)){
          this.errores.push("Indique un Mail válido")
        }
      }
      if(!this.errores.length) {
        return true
      } else {
        return false
      }
    },
    clasenombre () {
      if (this.nombre === '') return 'error-input'
    },
    clasetelefono () {
      if (this.telefono === '') return 'error-input'
    },
    clasemail () {
      if (!this.validEmail(this.mail)) return 'error-input'
    },
    clasedireccion () {
      if (this.direccion === '') return 'error-input'
    }
  },
  watch: {
     respuestapedidoapi: function (response) {
        if (response.data.pedido.status === 1) {
          this.$router.push('/pedidocompleto')  
        } else {
          alert('Error al procesar su pedido, verifique la informacion enviada')
        }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/js/enviarpedido.js